import { render, staticRenderFns } from "./ConnectOpenFinanceAccount.vue?vue&type=template&id=b8c6cf30&scoped=true&"
import script from "./ConnectOpenFinanceAccount.vue?vue&type=script&lang=js&"
export * from "./ConnectOpenFinanceAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c6cf30",
  null
  
)

export default component.exports